import { render, staticRenderFns } from "./footerNavigation.vue?vue&type=template&id=4bcc7649&"
import script from "./footerNavigation.vue?vue&type=script&lang=js&"
export * from "./footerNavigation.vue?vue&type=script&lang=js&"
import style0 from "./footerNavigation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports